import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'button[cm-link-button], a[cm-link-button]',
    standalone: false
})
export class CmLinkButtonDirective {
	@HostBinding('class.cm-link-button')
	elementClass = true;

	constructor() {}
}
